export default "__VITE_ASSET__fc969d1a__"